<template>
  <div>
    <v-card tile flat :max-width="widthOfCard">
      <!-- <v-img :src="getImageURL(product.image)" height="200px" cover></v-img> -->
     <v-img
        :src="baseURL + 'u/' + storage.productId.photos[0]"
        height="150px"
        contain
      >
        <v-layout wrap>
          <v-flex text-right pa-0>
            <v-avatar color="#FF3434" size="15">
              <v-icon color="#FFF" small @click="removeFromCart()">
                mdi-close
              </v-icon>
            </v-avatar>
          </v-flex>
        </v-layout>
        <template v-slot:placeholder> <ImageLoader /> </template>
      </v-img>
      <v-layout wrap justify-center px-2>
        <v-flex
          pt-2
          xs12
          text-left
          style="line-height: 16px; cursor: pointer"
          @click="
            $router.push(
              '/productdetailview/' + storage.productId.urlname
            )
          "
        >
          <span
            style="
              font-family: poppinssemibold;
              font-size: 13px;
              color: #000000;
            "
          >
            {{ storage.productId.productname.slice(0, 25) }}
            <span v-if="storage.productId.productname.length > 25"> ... </span>
          </span>
          <br />
          <span
            style="font-family: poppinsregular; font-size: 13px; color: #000000"
          >
            <!-- {{ product.category }} -->
            category
          </span>
          <br />
          <span
            style="
              font-family: poppinssemibold;
              font-size: 13px;
              color: #000000;
            "
          >
            Rs. {{ storage.productId.offerPrice }}
          </span>
          <span
            class="pl-12 text-decoration-line-through"
            style="font-family: poppinsregular; font-size: 13px; color: #ff0000"
          >
            Rs. {{ storage.productId.price }}
          </span>
          <br />
          <!-- <span>
            <v-rating
              v-model="storage.product.ratingcount"
              color="#FFD341"
              background-color="#e0e0e0"
              empty-icon="$ratingFull"
              half-increments
              readonly
              hover
              small
            ></v-rating>
          </span> -->
        </v-flex>
      </v-layout>
      <!-- <v-layout wrap justify-center>
        <v-flex xs12 px-2>
          <v-btn block tile color="#E9E9E9" dark :ripple="false" depressed>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 15px;
                text-transform: none;
                color: #000000;
              "
            >
              Check out
            </span>
          </v-btn>
        </v-flex>
      </v-layout> -->
    </v-card>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["storage", "cardWidth"],
  data() {
    return {
      widthOfCard: "250px",
    };
  },
  beforeMount() {
    if (this.cardWidth) {
      this.widthOfCard = this.cardWidth;
    }
  },
  methods: {
    removeFromCart() {
      var cart = {};
      cart["productid"] = this.storage.productId._id;
      
      var headers1 = {};
      if (this.$store.state.isLoggedIn) {
        headers1 = {
          "x-auth-token": localStorage.getItem("token"),
        };
      } else {
        cart["guestid"] = localStorage.getItem("guestId");
      }

      axios({
        method: "POST",
        url: "/Cart/Remove/"+ this.storage.productId._id,
        data: cart,
        headers: headers1,
      })
        .then((response) => {
          if (response.data.status) {
            this.$store.commit("changeCart", response.data.count);
            if (response.data.status) {
              this.$emit("stepper", {
                ref: "remove",
                response: response.data,
                getData: true,
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};

</script>